module.exports = __webpack_public_path__ + "img/personalcenter2.ec01f549.png";